import { On3IconSwapArrows } from '@on3/icons';
import { useAuth } from '@on3/ui-lib/src/contexts/AuthProvider';
import { databaseUrl } from '@on3/ui-lib/utils/api';
import { DatabaseLayout } from 'components/Layouts/DatabaseLayout';
import { Text } from 'components/UI/Typography/Text';
import useAthlete from 'contexts/AthleteProvider';
import type { IPlayerVitalsPageProps } from 'pages/db/[id]/vitals';

import { CompactHeader } from './Header/CompactHeader';
import { PlayerVital } from './PlayerVital';
import { PlayerVitalAverages } from './PlayerVitalAverages';
import styles from './PlayerVitalsList.module.scss';

interface PlayerVitalsListProps
  extends Omit<IPlayerVitalsPageProps, 'basicInfo'> {}

export const PlayerVitalsList = ({
  playerVitals,
  vitalAverages,
  sectionTitle,
}: PlayerVitalsListProps) => {
  const { hasRdbAccess, user } = useAuth();
  const { athlete } = useAthlete();

  const filteredPlayerVitals = playerVitals?.playerMeasurements?.filter(
    (v) => v.value && v.value > 0,
  );
  const showVitals = user?.has;

  return (
    <DatabaseLayout>
      <section>
        {hasRdbAccess() && (
          <a
            href={`${databaseUrl}/people/${athlete?.slug}/edit/`}
            rel="noopener noreferrer"
            target="_blank"
          >
            Edit
          </a>
        )}
        <CompactHeader basicInfo={athlete} />
        <Text className={styles.vitalsHeader} component="h2">
          {sectionTitle}
        </Text>
        {!!vitalAverages?.list?.length && (
          <PlayerVitalAverages
            className={styles.vitalAveragesModule}
            vitalAverages={vitalAverages}
          />
        )}
        {!!filteredPlayerVitals?.length && showVitals && (
          <>
            <Text className={styles.columnHeaderContainer} component="ol">
              <li>Date</li>
              <li>Category</li>
              <li>Level</li>
              <li>Event</li>
              <li className={styles.center}>Result</li>
              <li className={styles.swapArrowsHeader}>
                <On3IconSwapArrows height={14} width={20} />
              </li>
              <li className={styles.center}>
                Top 300 {athlete?.positionAbbreviation} Avg
              </li>
              <li className={styles.center}>
                {athlete?.defaultSport?.key === 1 ? 'NFL' : 'NBA'} Combine
                Drafted
              </li>
            </Text>

            <ul className={styles.listContainer}>
              {filteredPlayerVitals?.map((vital) => {
                return <PlayerVital {...vital} key={vital.key} />;
              })}
            </ul>
          </>
        )}
      </section>
    </DatabaseLayout>
  );
};
